import { api } from 'utils';
import { prepare } from './helper';
import { Payload, LGAZoneDetails, UnavailableZonesDetails } from './types';
import * as Interfaces from 'interfaces';

export default class PermitService {
  private adapter: api.Adapter;

  constructor(baseURL: string = process.env.REACT_APP_API_DOMAIN || '') {
    this.adapter = new api.Adapter({
      baseURL,
      headers: {
        timeout: 60 * 10 * 1000,
        'content-type': 'application/json',
        accept: 'application/json'
      }
    });
  }

  async createPermit(payload: Interfaces.Common.FormValues, transactionID: string): Promise<any> {
    const finalPayload = prepare(payload);
    const headers = { 'X-TransactionID': transactionID };
    const response = await this.adapter.postValue<Payload>('/v1/covid/travel', finalPayload, {
      headers
    });

    return response;
  }

  async lookupLGAZone(lga: string, transactionID: string): Promise<LGAZoneDetails> {
    const headers = { 'X-TransactionID': transactionID };
    const response = await this.adapter.getValue<LGAZoneDetails>(`/v1/covid/zone?lga=${lga}`, {
      headers
    });

    return response.data;
  }

  async lookupUnavailableZones() {
    const response = await this.adapter.getValue<UnavailableZonesDetails>(
      `/v1/covid/zones/unavailable`
    );

    return response.data.disabledZones;
  }
}
